import { createContext, useContext } from 'react'

export type FieldSize = 'default' | 'large'

const FieldSizeContext = createContext<FieldSize>('default')

export const FieldSizeProvider = FieldSizeContext.Provider

export const useFieldSize = () => useContext(FieldSizeContext)
